if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      setTimeout(() => {
        this.updateMedia()
      }, 100);
      window.updateProductDisabled = this.setDisabled
      window.updateProductMedia = this.updateMedia
      this.customizer_product = {}
      this.is_quick_view = false
      if($(this).closest("#Product-Drawer-Content").length > 0){
        this.customizer_product = window?.active_quick_view
        this.is_quick_view = true;
      }else {
        this.customizer_product = customizer_product;
      }
    }

    $SL(sl, f) {
      if(this.is_quick_view && !f){
        return $(this).closest("#Product-Drawer-Content").find(sl)
      }else {
        return $(sl)
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange(e, re) {
      this.updateOptions(e);
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      window.variant_change = true;

      if(this.current_option_idx){
        const nowIdx = this.current_option_idx?.idx
        let variants = this.customizer_product.product?.variants
        // if($)
        const options = this.customizer_product.product?.options
        const nowOption = options?.[nowIdx]
        
        this.$SL(`fieldset input[name="${nowOption}"]`).removeClass("is-disabled")
        this.$SL(`.has-variant-connection[data-name="${nowOption}"]`).removeClass("is-disabled")
        
        let changed = false;
        options?.forEach((v, idx) => {
          if(idx != nowIdx){
              let values = {}
              variants?.some((item) => {
                if (!values.hasOwnProperty(item?.["option"+(idx+1)])) {
                  values[item?.["option"+(idx+1)]] = false;
                }
                if(item?.["option"+(nowIdx+1)] == this.current_option_idx?.value){
                  values[item?.["option"+(idx+1)]] = true
                  return;
                }
              })
              Object.keys(values).forEach((idx) => {
                if(values[idx]){
                  this.$SL(`fieldset input[name="${v}"][value="${idx}"]`).removeClass("is-disabled")
                  this.$SL(`.has-variant-connection[data-name="${v}"][data-value="${idx}"]`).removeClass("is-disabled")
                }else {
                  this.$SL(`fieldset input[name="${v}"][value="${idx}"]`).addClass("is-disabled")
                  this.$SL(`.has-variant-connection[data-name="${v}"][data-value="${idx}"]`).addClass("is-disabled")
                }
              })

              if(this.$SL(`fieldset input[name="${v}"]:checked`).hasClass("is-disabled")){
                this.$SL(`fieldset input[name="${v}"]:not(.is-disabled)`).first().prop("checked", true)
                this.$SL(`.has-variant-connection[data-name="${v}"]:not(.is-disabled)`).first().addClass("active").siblings().removeClass('active')
                changed = true
              }
          }
        })
        if(changed){
          this.onVariantChange(e, true)
        }
      }
      this.setDisabled();

      this.updateOther();
      if(!this.is_quick_view){
        dispatchCustomEvent('product:variant-change', {
          variant: this.currentVariant,
          sectionId: this.dataset.section,
          force: re,
        });
      }

    }

    updateOptions(e) {
      const target = $(e?.target)
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.current_option_idx = 0;
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          const val = fieldset.querySelector('input:checked').value
          if(fieldset.querySelector('input:checked').getAttribute("name") == target?.attr("name")){
            this.current_option_idx = {idx: i, value: val};
          }
          this.options.push(val);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = "("+this.options[i]+")";
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      // if (!this.currentVariant) return;
      // if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      if(typeof this.customizer_product !== 'undefined' && this.customizer_product?.type != "ring" && this.customizer_product?.type != "necklace"){
        const variants = this.customizer_product?.product?.variants;
        const activeOption = this.currentVariant;
        
        let colorOptionIndex = false;
        this.customizer_product?.product?.options?.forEach((item, idx) => {
          const nameL = item?.toLowerCase()
          if(nameL?.includes("color") || nameL?.includes("colour") || nameL?.includes("couleur") || nameL?.includes("farbe")){
            colorOptionIndex = idx+1;
            // return;
          }
        })
        const activeColorVal = activeOption?.["option"+colorOptionIndex]
        this.$SL(".pco-img-bottom").removeClass("is-active is-selected").hide()
        let img;
        let featured_media_id = null
        let featured_medias = {}


        const $item = this.$SL(`.pco-img-bottom[data-id="${activeOption?.featured_media?.id}"]`)
        if($item?.length > 0){
          $item.show().addClass("is-active")
          if(!img){
              $item.addClass("is-selected")
              img = $item.find('img').attr("src")
          }
        }

        variants?.forEach((item, idx) => {
            featured_medias[item?.featured_media?.id] = true
            if(item?.["option"+colorOptionIndex] == activeColorVal){
                const $item = this.$SL(`.pco-img-bottom[data-id="${item?.featured_media?.id}"]`)
                $item.show().addClass("is-active")
                featured_media_id = item?.featured_media?.id
                if(!img){
                    $item.addClass("is-selected")
                    img = $item.find('img').attr("src")
                }
            }
        })
        let start = false
        for(let i = 0; i < this.customizer_product?.product?.media?.length; i++){
            const item = this.customizer_product?.product?.media[i]
            if(item?.id == featured_media_id && !start){
                start = true
            }
            if(start){
                if(!featured_medias[item?.id]){
                    const $item = this.$SL(`.pco-img-bottom[data-id="${item?.id}"]`)
                    $item.show().addClass("is-active")
                    if(!img){
                        $item.addClass("is-selected")
                        img = $item.find('img').attr("src")
                    }
                }else {
                    if(featured_media_id != item?.id){
                        break;
                    }
                }
            }
        }
        this.$SL(`.pco-img-bottom[data-alt-text]`).each(function() {
            const alt_texts = $(this).attr("data-alt-text")?.split(",")
            if(alt_texts?.includes(activeColorVal)){
                $(this).show().addClass("is-active")
                if(!img){
                    $(this).addClass("is-selected")
                    img = $(this).find('img').attr("src")
                }
            }
        })
        if(img){
            this.$SL('product-add-to-cart-sticky').find('.pco-img-1').attr("src", img)
        }
      }
      this.$SL(".thb-product-detail product-slider")[0].reInit()
      this.$SL('.product-image-container').addClass("changed")
      if(!this.currentVariant?.featured_media){
        this.currentVariant.featured_media = this.customizer_product?.product?.media?.[0]
      }
      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant?.featured_media?.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant?.featured_media?.id}`, this.productSlider, thumbnails);
      if(this.is_quick_view){
        this.$SL('.pco-img-bottom').removeClass('pco-active')
        this.$SL(`[data-id="${this.currentVariant?.featured_media?.id}"]`).addClass("pco-active").siblings().removeClass("pco-active")
      }
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {


        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", this.currentVariant.id);
      window.history.replaceState({}, '', url.toString());
      // window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      const url = new URL(window.location.href);
      url.searchParams.set(variant, this.currentVariant.id);
      shareButton.updateUrl(url.toString());
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          window.customizer_price_udpate(false, this.currentVariant)
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];
          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                const $input = $(input)
                if(fieldset_options[input_i].isUnavailable){
                  // $input.addClass('is-disabled').prop("disabled", true)
                  $input.addClass('is-disabled')
                  if($input.is(":checked")){
                    this.$SL(`.has-variant-connection[data-name="${$input.attr("name")}"][data-value="${$input.attr('value')}"]`).siblings(".has-variant-connection:not(.is-disabled)").first().click()
                  }
                  // this.$SL(`.has-variant-connection[data-name="${$input.attr("name")}"][data-value="${$input.attr('value')}"]`).addClass("is-disabled").prop("disabled", true)
                  this.$SL(`.has-variant-connection[data-name="${$input.attr("name")}"][data-value="${$input.attr('value')}"]`).addClass("is-disabled")
                }else {
                  $input.removeClass('is-disabled').prop("disabled", false)
                  this.$SL(`.has-variant-connection[data-name="${$input.attr("name")}"][data-value="${$input.attr('value')}"]`).removeClass("is-disabled").prop("disabled", false)
                }
                // input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

        // this.fieldsets.forEach((fieldset, i) => {
        //   if(this.$SL(fieldset).find(`input[checked]`).hasClass("is-disabled")){
        //     this.$SL(fieldset).find(`input:not(.is-disabled)`).first().prop("checked", true).trigger("change")
        //   }
        // })

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTreePrev(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      const options = { option1: [], option2: [], option3: [] };
    
      // Step 1: Collect all options and track linked variants
      const optionMap = { option1: {}, option2: {}, option3: {} };
    
      variants.forEach(variant => {
        ["option1", "option2", "option3"].forEach(index => {
          if (variant[index] !== null) {
            if (!optionMap[index][variant[index]]) {
              optionMap[index][variant[index]] = { value: variant[index], isUnavailable: true, linkedVariants: [] };
            }
            optionMap[index][variant[index]].linkedVariants.push(variant);
          }
        });
      });
    
      // Step 2: Build the options list
      Object.keys(optionMap).forEach(optionKey => {
        options[optionKey] = Object.values(optionMap[optionKey]);
      });
    
      // Step 3: Get currently selected values
      const selectedOption1 = currentlySelectedValues.find(sel => sel.index === "option1")?.value;
      const selectedOption2 = currentlySelectedValues.find(sel => sel.index === "option2")?.value;
      const selectedOption3 = currentlySelectedValues.find(sel => sel.index === "option3")?.value;
    
      // Step 4: Top-Down Filtering
      options.option1.forEach(option => {
        option.isUnavailable = !option.linkedVariants.some(v => v.available);
      });
    
      options.option2.forEach(option => {
        option.isUnavailable = !option.linkedVariants.some(v =>
          v.available &&
          (!selectedOption1 || v.option1 === selectedOption1)
        );
      });
    
      options.option3.forEach(option => {
        option.isUnavailable = !option.linkedVariants.some(v =>
          v.available &&
          (!selectedOption1 || v.option1 === selectedOption1) &&
          (!selectedOption2 || v.option2 === selectedOption2)
        );
      });
    
      // Step 5: Bottom-Up Filtering
      if (selectedOption2) {
        options.option1.forEach(option => {
          option.isUnavailable = !option.linkedVariants.some(v =>
            v.available && v.option2 === selectedOption2
          );
        });
      }
    
      if (selectedOption3) {
        options.option1.forEach(option => {
          option.isUnavailable = !option.linkedVariants.some(v =>
            v.available && v.option3 === selectedOption3
          );
        });
    
        options.option2.forEach(option => {
          option.isUnavailable = !option.linkedVariants.some(v =>
            v.available && v.option3 === selectedOption3
          );
        });
      }
    
      return options;
    }      
    

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      // if($(this).closest(".side-panel.product-drawer").length > 0){
      //   console.log('adf')
      //   return
      // }
      if(this.getAttribute("data-thumbnail") != "slider"){
        var thumb_items = {};
        this.querySelectorAll("img").forEach(((link, idx) => {
          link.addEventListener('click', (e) => {if(thumb_items[idx]){
            thumb_items[idx].dispatchEvent(new Event('click'));
            }else {
              this.zoomClick(e, link, idx)
            }
          });
        }));
        this.product_container.querySelectorAll('.product-thumbnail').forEach((thumb, idx) => {
          thumb_items[idx] = thumb
          thumb.addEventListener("click", (e) => {
            setTimeout(() => {
              this.zoomClick(e, thumb, idx)
            }, 30);
          })
        });
        // return;
      }
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      this.setEventListeners();

      // Start Gallery
      this.setupProductGallery();
    }
    // reInit(imageSetIndex) {

    //   this.flkty.destroy();

    //   this.setOptions();

    //   this.flkty = new Flickity(this, this.options);

    //   // Setup Events
    //   this.setupEvents();

    //   this.selectedIndex = imageSetIndex ?? this.flkty.selectedIndex;
    // }

    reInit(imageSetIndex = 0) {
      // if($(this).closest(".side-panel.product-drawer").length > 0){
      //   console.log('adf')
      //   return
      // }
      if (this.flkty) {
        this.flkty.destroy(); 
      }
      this.setOptions(); 
      this.flkty = new Flickity(this, this.options);
      this.setupEvents();
      this.selectedIndex = imageSetIndex ?? this.flkty.selectedIndex;
      this.setupProductGallery();
      this.init()
    }
    

    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode?.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode?.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');
        if(activelink){
          activelink.dataset.index = index;
          return {
            src: activelink.getAttribute('href'),
            msrc: activelink.dataset.msrc,
            w: activelink.dataset.w,
            h: activelink.dataset.h
          };
        }
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected');
          // if(!thumbnail){
          //   return {}
          // }
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const  rect = thumbnail?.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link, index) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset?.index ?? index ?? 0, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
$(document).ready(function() {
  document.getElementById("AddToCartSticky")?.addEventListener("click", function() {
    // $("product-form form")[0].submit()
    $("#AddToCart").trigger("click")
  })
})
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.customizer_product = {}
      this.is_quick_view = false
      if($(this).closest("#Product-Drawer-Content").length > 0){
        this.customizer_product = window?.active_quick_view
        this.is_quick_view = true;
      }else {
        this.customizer_product = customizer_product;
      }
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.timeoutcheck = null;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      if(evt){
        evt.preventDefault();
      }
      clearTimeout(this.timeoutcheck);

      this.timeoutcheck = setTimeout(() => {

        if (!this.form.reportValidity()) {
          return;
        }
  
        let extra_price = 0;
        if(typeof this.customizer_product !== undefined && (this.customizer_product?.type != "ring" || this.customizer_product?.type != "necklace")){ 
          let okay = true;
          $(".pco-is-required").each(function() {
            const name = $(this).attr("data-name")
            let item = null;
            let is_okay = false
            if(name?.includes("engraving__v_")){
              item = PCO_VALUES?.engraving_list?.[name]
              is_okay = item?.text?.length > 0
            }else {
              item = PCO_VALUES?.[name]
              is_okay = item?.value ?? item?.label
            }
            if(!is_okay){
              const $collapse = $(this).closest(".MuiCollapse")
              let timeout = 0
              if(!$collapse.hasClass("active")){
                $collapse.addClass("active");
                $collapse.children(".MuiCollapse-wrapper").addClass("visible").animate({ height: "auto" }, 300);
                $collapse.children(".MuiCollapse-wrapper").addClass("visible").css({ height: "auto" });
                // $collapse.children(".MuiCollapse-wrapper").addClass("visible").animate({ height: "calc-size(auto)" }, 300);
                timeout = 300
              }
              if(!okay){
                setTimeout(() => {
                  $([document.documentElement, document.body]).animate({
                      scrollTop: $(this).offset().top - 200
                  }, 300);
                }, timeout);
              }
              $(`.warning-message-inp[data-name="${name}"]`).html(`<span>Dies ist ein Pflichtfeld.</span>`)
              okay = false
            }
          })
          if(!okay){
            return
          }
          const $customizationInformations = $(this.form)
          $customizationInformations.find(`.pco-custom-properties`).remove()
          Object?.keys(PCO_VALUES ?? {}).map((key) =>{
            if(!PCO_VARIANT_CONNECTIONS[key]){
              const item = PCO_VALUES[key]
  
              const vItemIdx = PCO_VARIANT_OPTIONS?.[key]?.findIndex((obj) => obj.id == item?.id)
              const vItem = PCO_VARIANT_OPTIONS?.[key]?.[vItemIdx]
  
  
              let name = vItem?.name;
              let value = vItem?.value ?? vItem?.label
              if(name && value){
                $customizationInformations.append(`<input class="pco-custom-properties" name="properties[${name}]" value="${value}" type="hidden" />`)
              }
              if(vItem?.is_stone){
                const stone_obj = [
                    {obj: 'stone_certification', label: "Certification"},
                    {obj: 'stone_color', label: "Farbe"},
                    {obj: 'stone_clarity', label: "Purity"},
                    {obj: 'stone_cutshape', label: "Cut Shape"},
                    {obj: 'stone_cut', label: "Cut"},
                    {obj: 'stone_carat', label: "Carat"},
                    {obj: 'stone_quantity', label: "Number of stones"},
                    {obj: 'stone_diameter', label: "Stone Diameter"},
                ]
                stone_obj.forEach((obj) => {
                    const obj_i = vItem?.[obj?.obj]
                    if(obj_i){
                        $customizationInformations.append(`<input class="pco-custom-properties" name="properties[${obj?.label}]" value="${obj_i}" type="hidden" />`)
                    }
                })
              }
            }
          })
  
          if(PCO_VALUES?.engraving_list){
            Object.keys(PCO_VALUES.engraving_list).map(key => {
              const item = PCO_VALUES.engraving_list[key]
              const name = item?.name?.replace("engraving__v__", "")
              if(item?.text){
                $customizationInformations.append(`<input class="pco-custom-properties" name="properties[${name}]" value="${item?.text}" type="hidden" />`)
                if(item?.font){
                  $customizationInformations.append(`<input class="pco-custom-properties" name="properties[${name} Schriftart]" value="${item?.font}" type="hidden" />`)
                }
              }
            })
          }
  
          if(PCO_PRICING_REF && typeof PCO_PRICING_REF == "object"){
              Object.keys(PCO_PRICING_REF).forEach(key => {
                extra_price += parseFloat(PCO_PRICING_REF[key] ?? 0)
              })
          }
        }
  
  
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
  
        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });
        $("#AddToCartSticky, #AddToCart").attr("disabled", true).attr("loading", true)
  
  
        this.handleErrorMessage();
        var newVariantID;
   
        const call = () => {
  
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
  
          let formData = new FormData(this.form);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);
          
          if(newVariantID){
            formData.set('id', newVariantID);
          }
  
          config.body = formData;
  
          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                dispatchCustomEvent('product:variant-error', {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message
                });
                if (response.status === 422) {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                  }));
                }
                this.handleErrorMessage(response.description);
                return;
              }
  
              this.renderContents(response);
  
              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
              // if (document.getElementById('Cart-Drawer')) {
              //   document.getElementById('Cart-Drawer').open();
              // }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButtons.forEach((submitButton) => {
                submitButton.classList.remove('loading');
                submitButton.classList.remove('pplr_adding');
                submitButton.removeAttribute('aria-disabled');
              });
              $("#AddToCartSticky, #AddToCart").attr("disabled", false).attr("loading", false)
            });
        }
  
  
        if(extra_price > 0){
          const img_src_l = ($("#pco-img-1").attr("src"))
          const variant = $('variant-selects')?.[0]?.currentVariant
          const json_obj = {
            ...this.customizer_product?.product,
            ...variant,
            vtitle: variant?.title,
            title: this.customizer_product?.product?.title,
            price: parseFloat(extra_price) + (parseFloat(variant?.price) / 100),
            image_url: "https://meinekette.de"+(img_src_l?.replace("https://meinekette.de", "").replace("//www.meinekette.de", ""))
          }
  
          fetch('https://personaly-meinekette-custom.de/add-to-cart.php?v=11', {
            // fetch('http://127.0.0.1:8000/api-add-to-cart?v=11', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(json_obj)
          })
            .then(response => response.json())
            .then(data => {
              newVariantID = data?.variants[0]?.id
              call()
            })
            .catch(error => {
              $("#AddToCartSticky, #AddToCart").attr("disabled", false).attr("loading", false)
              console.error('Error:', error);
            });
          
        }else {
          call()
        }

      }, 20)
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent(); 
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if(search_drawer){
        if (search_drawer.classList.contains('active')) {
          search_drawer.classList.remove('active');
        }
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').open();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if(!button){
        return
      }
      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form?.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height - 400)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}